import { SUBSCRIBE, SUBSCRIBE_FAILD, SUBSCRIBE_SUCCESS } from "./types";

//trip section
export function subscribe(params) {
  return {
    type: SUBSCRIBE,
    params,
  };
}

export function subscribeSuccess(payload) {
  return {
    type: SUBSCRIBE_SUCCESS,
    payload: payload,
  };
}
export function subscribeFail(params) {
  return {
    type: SUBSCRIBE_FAILD,
    params,
  };
}
